import Alpine from "alpinejs";

// Füge diese Zeile hinzu, um zu sehen, wie oft der Code läuft
console.log("Alpine wird initialisiert...");

document.addEventListener("DOMContentLoaded", () => {
  window.Alpine = Alpine;
  Alpine.start();
});
